import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom'
import { connect } from 'react-redux';
import {authenticated} from '../../actions/authActions'

class callback extends Component {
    componentDidMount(){
        const data = (/#access_token=(.*)&token_type/).exec(this.props.location.hash)
        this.props.authenticated(this.props.history,data[1])
        
    }
    render() {
        return (
            <div>
                
            </div>
        )
    }
}
//http://localhost:3000/auth/callback#access_token=..---ndg0oBOvTJQa8CM55Mr-&token_type=Bearer&expires_in=3599&scope=api%3a%2f%2f343ed40a-80a3-43e8-84a8-d7f9c18fcf0a%2fUser.read&session_state=15d3cfd3-34d4-41d1-93f7-4b068f906c7e

callback.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
  };
  
  const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
  });
  
  export default connect(mapStateToProps,{authenticated})(withRouter(callback));


// WEBPACK FOOTER //
// ./src/components/auth/callback.js